import { render, staticRenderFns } from "./MainMenuEntity.vue?vue&type=template&id=34bd8a2b&"
import script from "./MainMenuEntity.vue?vue&type=script&lang=js&"
export * from "./MainMenuEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports